import {useNavigate, useSearchParams} from "react-router-dom";
import {shiftSelector, useGetShiftQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {ShiftProfile} from "../../components/profile/ShiftProfile/ShiftProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {useTranslation} from "react-i18next";

type Props = {
  id?: string;
}

export const ShiftProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.shift", "Shift") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <ShiftProfilePage id={id}/>;
};

export const ShiftProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const selectShift = useMemo(() => {
    return shiftSelector()
  }, []);

  const {shift, isFetching} = useGetShiftQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      shift: selectShift(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage permissions={["shift_view"]} entity={shift} isLoading={isFetching} onAccess={setAccess}>
      {(entity) => (
        <ShiftProfile shift={entity}/>
      )}
    </EntityProfilePage>
  )
};
